$(document).ready(function() {
    showUserInactivityModal = function() {
        clearInterval(showUserInactivityModalInterval);
        $('#user_inactivity_modal').modal('show');
        $.ajax('/ifp/expire', { method: 'PUT' });
    };

    showUserInactivityModalInterval=setInterval(showUserInactivityModal, 10800000);
});
